import React, { Component } from 'react';
import StyleSheet from 'stilr';
import { spacing } from '../../styles';
import { Grid, Cell, palm, findMatch } from 'react-flexr';
import { createEPIQuery } from '../../../utils/epi';
import Chip from '../../labelChip';

const styles = StyleSheet.create({
  result: {
    background: 'white',
    border: '1px solid lightgrey',
    padding: '0.8em 1em 0',
    lineHeight: 1.2
  },

  discounted: {
    borderColor: '#FFDD00',
    borderWidth: 2,
    paddingTop: '1.3em'
  },

  tagline: {
    position: 'absolute',
    width: '100%',
    top: -13,
    left: 0,
    textAlign: 'center',
    fontSize: '15px'
  },
  taglineContainer: {
    font: 'normal 13px arial, sans-serif',
    backgroundColor: '#FFEE00',
    color: '#333333',
    border: '1px solid #FFDD00',
    display: 'inline-block',
    whiteSpace: 'initial',
    maxWidth: '100%'
  },
  taglineLabel: {
    whiteSpace: 'nowrap',
    display: 'inline-block',
    fontWeight: 'bold'
  },
  taglineExpire: {
    whiteSpace: 'nowrap',
    display: 'inline-block',
    ':before': {
      content: '" - "',
      display: 'inline-block',
      paddingLeft: 5,
      paddingRight: 5
    }
  },
  logoContainer: {
    alignSelf: 'center'
  },
  logo: {
    maxWidth: '100%',
    border: 0,
    maxHeight: 70,
    [palm]: {
      width: 'auto',
      height: 50,
      maxWidth: '100%'
    }
  },

  c2aContainer: {
    alignSelf: 'flex-end',
    textAlign: 'center',
    lineHeight: 1.2
  },
  c2aBtn: {},
  c2aTxt: {
    marginTop: '1em',
    fontSize: '75%',
    display: 'block',
    textDecoration: 'underline'
  },

  mainContainer: {
    textAlign: 'center',
    marginBottm: 11
  },

  detailsTable: {
    width: '100%',
    marginBottom: '1em'
  },
  detailsTableRow: {
    borderBottom: '1px solid #ccc'
  },
  // detailsTableHeaderCell: {
  //   textTransform: 'capitalize'
  // },
  detailsTableValueCell: {
    textAlign: 'right',
    padding: '3px 0'
  },

  detailsWrapper: {
    alignSelf: 'center'
  },
  detailsContainer: {
    marginBottom: -11
  },
  detailContainer: {
    alignSelf: 'flex-end',
    marginBottom: 11,
    whiteSpace: 'pre'
  },
  detailValue: {
    fontSize: '1.4em',
    whiteSpace: 'nowrap',
    [palm]: {
      fontSize: '1.3em'
    }
  },
  detailValueMasked: {
    fontSize: '1.3em'
  },
  priceContainer: {
    alignSelf: 'center'
  },
  priceAmount: {
    fontSize: '1.8em',
    [palm]: {
      fontSize: '1.4em'
    }
  },
  priceOld: {
    marginRight: 5,
    fontSize: '1.4em',
    [palm]: {
      fontSize: '1.3em'
    }
  },
  labelsContainer: {
    marginTop: '-1em',
    marginBottom: 11
  },
  commonLabel: {
    display: 'inline-block',
    fontSize: '1em',
    padding: '.3em .7em .4em .4em',
    marginTop: '0.5em',
    marginRight: '0.5em',
    fontWeight: 'normal',
    maxWidth: '600px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    ':before': {
      marginRight: 5,
      display: 'inline-block',
      font: 'normal normal normal 14px/1 FontAwesome',
      fontSize: 'inherit',
      textRendering: 'auto',
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale'
    },
    [palm]: {
      fontSize: '.9em',
      maxWidth: 'calc(100vw - 60px)'
    }
  },
  uspLabel: {
    backgroundColor: 'rgba(33, 150, 243, 0.10)', // rgba(76, 175, 80, 0.10)
    color: 'rgb(33, 150, 243)', // rgb(76, 175, 80)
    border: '1px solid rgb(33, 150, 243)', // rgb(76, 175, 80)
    ':before': {
      content: '"\\F00C"'
    }
  },
  requirementLabel: {
    backgroundColor: 'rgba(255, 196, 20, 0.51)', // rgba(76, 175, 80, 0.10)
    color: 'rgb(136, 96, 0)', // rgb(76, 175, 80)
    border: '1px solid rgb(167, 132, 0)', // rgb(76, 175, 80)
    ':before': {
      content: '"\\F12A"'
    }
  },

  additionalRemarks: {
    marginBottom: 11,
    paddingTop: 11,
    borderTop: '1px solid lightgrey',
    fontSize: 12
  },

  product: {
    marginTop: 10,
    display: 'inline-block'
  }
});

class ResultRow extends Component {
  // Define propTypes
  // Implement @PureRender
  // Trigger re-render on breakpoint changes

  shouldComponentUpdate(nextProps) {
    return nextProps.data !== this.props.data || nextProps.addressId !== this.props.addressId || nextProps.siteId !== this.props.siteId || nextProps.feed !== this.props.feed || nextProps.url !== this.props.url || nextProps.filtersUsed !== this.props.filtersUsed;
  }

  render() {
    const { data, addressId, siteId, url, feed, filtersUsed, offerType } = this.props;

    const link = data.get('link') + createEPIQuery({ siteId, url, feed, filtersUsed }, addressId);
    const tagline = data.get('tagline') || '';
    const expire = data.get('expire') || '';
    const orderText = data.get('orderText') || 'Bestil Tilbud';

    const details = data.get('details');
    const detailsLength = details ? (details.size || 0) > 3 : false;
    const price = data.get('price');
    const priceSixMonth = data.get('priceSixMonth');
    const usps = data.get('usps');
    const requirements = data.get('requirements');
    const product = data.get('product');
    const productDescription = data.get('productDescription');
    const discountCode = data.get('discountCode');

    const prices = data.get('prices');

    const logo = data.get('logo') ? (
      <img
        src={data.get('logo')}
        alt={data.get('provider')}
        className={styles.logo}
      />
    ) : (
      <span>{data.get('provider')}</span>
    );

    const provider = null || data.get('provider');
    const providerFilterUrl = (feed ? link : '/' + offerType +  '/' + provider).toLowerCase().replace(/\s+/g, '-');

    const isPalm = findMatch('palm');

    return (
      <div
        className={[styles.result, tagline ? styles.discounted : null]
          .filter(Boolean)
          .join(' ')}
      >
        {tagline && tagline.length < 50 ? (
          <div className={styles.tagline}>
            <span className={`label label-warning ${styles.taglineContainer}`}>
              <span className={styles.taglineLabel}>{tagline}</span>
              {expire ? (
                <span
                  className={styles.taglineExpire}
                >{`Udløber d. ${expire}`}</span>
              ) : null}
            </span>
          </div>
        ) : null}

        <Grid className={styles.mainContainer}>
          <Cell
            size={100 + spacing(2)}
            palm='1/1'
            className={styles.logoContainer}
          >
            {logo ? (
              <a href={providerFilterUrl} target='_blank'>
                {logo}
              </a>
            ) : (
              logo
            )}
            {provider ? (
              <a href={providerFilterUrl} target='_blank' className={styles.product}>
                {provider}
              </a>
            ) : null}
          </Cell>
          <Cell className={styles.detailsWrapper}>
            {isPalm ? (
              <table className={styles.detailsTable}>
                <tbody>
                  {(data.get('details') || []).map((detail, idx) => {
                    if (detail.get('palm') === 'hidden' && isPalm) {
                      return null;
                    }
                    return (
                      <tr key={idx} className={styles.detailsTableRow}>
                        <th className={styles.detailsTableHeaderCell}>{`${detail
                          .get('label')
                          .substr(0, 1)
                          .toUpperCase()}${detail.get('label').substr(1)}`}</th>
                        <td className={styles.detailsTableValueCell}>
                          {detail.get('old') && (
                            <strike className={styles.priceOld} style={{ textWrap: 'auto' }}>
                              {detail.get('old')}
                            </strike>
                          )}
                          {detail.get('mask') ? (
                            detail.get('value')
                          ) : (
                            <strong className={styles.detailValue} style={{ textWrap: 'auto' }}>
                              {detail.get('value')}
                            </strong>
                          )}
                          {detail.get('unit') ? ` ${detail.get('unit')}` : null}
                        </td>
                      </tr>
                    );
                  })}
                  {priceSixMonth ? <tr>
                    <th className={styles.detailsTableHeaderCell}>{`${priceSixMonth
                      .get('label')
                      .substr(0, 1)
                      .toUpperCase()}${priceSixMonth.get('label').substr(1)}`}</th>
                    <td className={styles.detailsTableValueCell}>
                      {priceSixMonth.get('old') && (
                        <strike className={styles.priceOld}>
                          {priceSixMonth.get('old')}
                        </strike>
                      )}
                      <strong className={styles.priceAmount}>
                        {priceSixMonth.get('value')}
                      </strong>
                      {priceSixMonth.get('unit') ? ` ${priceSixMonth.get('unit')}` : null}
                    </td>
                  </tr> : null}
                  {prices ? 
                    prices.map((v) => (
                      <tr>
                      <th className={styles.detailsTableHeaderCell}>{`${v
                        .get('label')
                        .substr(0, 1)
                        .toUpperCase()}${v.get('label').substr(1)}`}</th>
                      <td className={styles.detailsTableValueCell}>
                        {v.get('old') && (
                          <strike className={styles.priceOld}>
                            {v.get('old')}
                          </strike>
                        )}
                        <strong className={styles.priceAmount}>
                          {v.get('value')}
                        </strong>
                        {v.get('unit') ? ` ${v.get('unit')}` : null}
                      </td>
                    </tr> 
                    ))
                  : <tr>
                    <th className={styles.detailsTableHeaderCell}>{`${price
                      .get('label')
                      .substr(0, 1)
                      .toUpperCase()}${price.get('label').substr(1)}`}</th>
                    <td className={styles.detailsTableValueCell}>
                      {price.get('old') && (
                        <strike className={styles.priceOld}>
                          {price.get('old')}
                        </strike>
                      )}
                      <strong className={styles.priceAmount}>
                        {price.get('value')}
                      </strong>
                      {price.get('unit') ? ` ${price.get('unit')}` : null}
                    </td>
                  </tr>}
                </tbody>
              </table>
            ) : (
              <Grid className={styles.detailsContainer}>
                {(data.get('details') || []).map((detail, idx) => {
                  return (
                    <Cell
                      key={detail.get('label') || idx}
                      size={
                        detail.get('size') || (detailsLength ? '1/3' : null)
                      }
                      className={styles.detailContainer}
                    >
                      {detail.get('old') && (
                        <strike className={styles.priceOld} style={{ textWrap: 'auto' }}>
                          {detail.get('old')}
                        </strike>
                      )}
                      {detail.get('mask') ? (
                        <span className={styles.detailValueMasked} style={{ textWrap: 'auto' }}>
                          {detail.get('value')}
                        </span>
                      ) : (
                        <strong className={styles.detailValue} style={{ textWrap: 'auto' }}>
                          {detail.get('value')}
                        </strong>
                      )}
                      {detail.get('unit') ? ` ${detail.get('unit')}` : null}
                      <br />
                      <small>{detail.get('label')}</small>
                    </Cell>
                  );
                })}
              </Grid>
            )}
          </Cell>
          {!isPalm ? prices ? 
          (
            <Cell className={styles.priceContainer} style={{ display: prices.length ? 'flex' : 'none' }}>
                {prices.map((v) => {
                  return (<Cell className={styles.priceContainer}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <strike className={styles.priceOld}>{v.get('old')}{v.get('old') && v.get('unit') ? ` ${v.get('unit')}` : null}</strike>
                      <strong className={styles.priceAmount}>
                        {v.get('value')}{v.get('unit') ? ` ${v.get('unit')}` : null}
                      </strong>
                    </div>
                    <small>{v.get('label')}</small>
                  </Cell>);
                })}
            </Cell>) : priceSixMonth ? (
            <Cell className={styles.priceContainer} style={{ display: 'flex' }}>
                <Cell className={styles.priceContainer}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <strike className={styles.priceOld}>{priceSixMonth.get('old')}{priceSixMonth.get('old') && priceSixMonth.get('unit') ? ` ${priceSixMonth.get('unit')}` : null}</strike>
                    <strong className={styles.priceAmount}>
                      {priceSixMonth.get('value')}{priceSixMonth.get('unit') ? ` ${priceSixMonth.get('unit')}` : null}
                    </strong>
                  </div>
                  <small>{priceSixMonth.get('label')}</small>
                </Cell>
                <Cell className={styles.priceContainer}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <strike className={styles.priceOld}>{price.get('old')}{price.get('old') && price.get('unit') ? ` ${price.get('unit')}` : null}</strike>
                    <strong className={styles.priceAmount}>
                      {price.get('value')}{price.get('unit') ? ` ${price.get('unit')}` : null}
                    </strong>
                  </div>
                  <small>{price.get('label')}</small>
                </Cell>
            </Cell>
          ): (
            <Cell size={130} className={styles.priceContainer}>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <strike className={styles.priceOld}>{price.get('old')}{price.get('old') && price.get('unit') ? ` ${price.get('unit')}` : null}</strike>
                <strong className={styles.priceAmount}>
                  {price.get('value')}{price.get('unit') ? ` ${price.get('unit')}` : null}
                </strong>
              </div>
              <small>{price.get('label')}</small>
            </Cell>
          ) : null}
          <Cell
            size={126 + spacing(2)}
            style={{ width: 'min-content' }}
            palm='1/1'
            className={styles.c2aContainer}
          >
            {data.get('link') ? (
              <div>
                Annonce
                <br />
                {/* <button 
                  onclick={() => { windows.location.href = data.get('link') + createEPIQuery(epiValues, this.props.addressId); }} 
                  id='myButton' 
                  className={`btn btn-success btn-block ${styles.c2aBtn}`}
                >
                  {orderText + 'test' }
                </button> */}
                <a
                  href={encodeURI(link)}
                  target='_blank'
                  className={`btn btn-success btn-block ${styles.c2aBtn}`}
                  style={{ marginTop: 8 }}
                >
                  {orderText} &rsaquo;
                </a>
                {!isPalm && (
                  <a href={encodeURI(link)} target='_blank' className={styles.c2aTxt}>
                    {`Få mere info på ${data.get('provider')}'s hjemmeside`}
                  </a>
                )}
              </div>
            ) : null}
          </Cell>
        </Grid>

        {(usps && usps.size) || (requirements && requirements.size) ? (
          <Grid className={styles.labelsContainer}>
            <Cell>
              {usps.map((usp, idx) => (
                <Chip key={idx} kind='usp' icon='ok'>
                  {usp}
                </Chip>
              ))}
              {requirements && requirements.map((req, idx) => (
                <Chip key={idx} kind='req' icon='warning-sign'>
                  {req}
                </Chip>
              ))}
            </Cell>
          </Grid>
        ) : null}

        {data.get('remark') ? (<span style={{ textWrap: 'wrap' }} className={`${styles.commonLabel} ${styles.requirementLabel} label`}>
            <strong>{data.getIn(['remark', 'headline'])}</strong>{' '}
            {data.getIn(['remark', 'text'])}
        </span>
        ) : null}

        {product ? (
          <p className={styles.additionalRemarks}>
            <strong>{'Produkt:'}</strong> {product}
          </p>
        ) : null}
        {productDescription ? (
          <p className={styles.additionalRemarks}>
            <strong>{'Beskrivelse:'}</strong> {productDescription}
          </p>
        ) : null}
        {discountCode ? (
          <p className={styles.additionalRemarks}>
            <strong>{'Rabatkode:'}</strong> {discountCode}
          </p>
        ) : null}

        {data.get('remarks') ? (
          <p className={styles.additionalRemarks}>
            <strong>{data.getIn(['remarks', 'headline'])}</strong>{' '}
            {data.getIn(['remarks', 'text'])}
          </p>
        ) : null}
      </div>
    );
  }
}

export default ResultRow;
